<script>
  import { colors } from "../utils/colors.ts";
  export let isActive = false;
  export let onСlick = () => {};
</script>

<style>
 span {
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    color: var(--green);
    position: absolute;
  }
  span::before {
    display: var(--display);
    content: "-";
    position: absolute;
    left: -4.5px;
    font-size: 14px;
  }
</style>

<span style="--green: {colors.green}; --display: {isActive === true || isActive === null ? "block" : "none"}" class:isActive on:click={onСlick}>
  {#if isActive === true}▾{:else if isActive === null}■{:else}▸{/if}
</span>
